import React from 'react';
import PropTypes from 'prop-types';

const LibraryItemSkeleton = ({ isVideo }) => (
  <div
    className={`skeleton-item library-item-skeleton ${
      isVideo ? '--video' : ''
    }`}
  >
    <div className="skeleton-item__body">
      <div className="skeleton-item__media"></div>
      <div className="skeleton-item__content">
        <div className="skeleton-item__tag"></div>
        <div className="skeleton-item__title"></div>
        <div className="skeleton-item__description skeleton-item__description--long"></div>
        <div className="skeleton-item__description"></div>
        <div className="skeleton-item__footer"></div>
      </div>
      {isVideo && (
        <div className="skeleton-item__sub-content">
          <div className="skeleton-item__description skeleton-item__description--long"></div>
          <div className="skeleton-item__description"></div>
        </div>
      )}
    </div>
  </div>
);

LibraryItemSkeleton.propTypes = {
  isVideo: PropTypes.bool.isRequired,
};

LibraryItemSkeleton.defaultProps = {};

export default LibraryItemSkeleton;
